module.exports = __webpack_public_path__ + "23a45c53c7d7c47adeee575a47552a4d.pdf";